module.exports = __webpack_public_path__ + "static/img/right-bottom-row-2.71873fc0.webp";